import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { ActionsButton } from "./style"
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';



const GenericButton = ({
  primaryColor,
  textColor = '#ffffff',    // Default text color
  type = 'default',           // Default type
  onClick,
  onContextMenu,
  width = '25px',             // Default width
  height = '25px',            // Default height
  icon = 'more-horizontal',   // Default icon button
  iconWidth = '17px',         // Default icon width
  text,
  style,
  ...rest
}) => {
  const { translate: t } = useDictionaryTranslation();
  return (
    <ActionsButton
      primaryColor={primaryColor}
      textColor={textColor}
      width={width}
      height={height}
      iconWidth={iconWidth}
      type={type}
      onClick={onClick}
      onContextMenu={onContextMenu}
      style={style}
      {...rest}
    >
      {t(text)}{icon && <FeatherIcon icon={icon} />}
    </ActionsButton>
  )
}

GenericButton.propTypes = {
  primaryColor: PropTypes.string,
  textColor: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  onContextMenu: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  icon: PropTypes.string,
  iconWidth: PropTypes.string,
  text: PropTypes.string,
  style: PropTypes.string
};

export { GenericButton }